var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Grid, Stack, List, Modal, ListItemIcon, ListItemButton, } from '@mui/material';
import { Fragment, useState } from 'react';
import { DisplayMarkdown } from './DisplayMarkdown';
import { getIsMobile } from '../../services/utilisateur';
import { ActiviteIcon, AffaireIcon, DocumentIcon, StatistiqueIcon, CatalogueIcon, ClientIcon, HelpIcon, StarsIcon, CollaborateurIcon, } from '../../utils/Icons';
import { Typography } from '../../utils/Typography';
export var Documentation = function () {
    var isMobile = getIsMobile();
    var _a = useState(false), focusImages = _a[0], setFocusImages = _a[1];
    var _b = useState(Object.values(options)[0].descriptions[0].label), selected = _b[0], setSelected = _b[1];
    var optionsForDemo = Object.values(options);
    var demos = optionsForDemo.reduce(function (acc, item) {
        acc.push.apply(acc, item.descriptions.map(function (description) {
            description.color = item.color;
            return description;
        }));
        return acc;
    }, []);
    var descriptionSelected = demos.find(function (image) { return image.label === selected; });
    var details = descriptionSelected && descriptionSelected.details
        ? descriptionSelected.details
        : null;
    var images = descriptionSelected && descriptionSelected.images
        ? descriptionSelected.images
        : [];
    var renderImage = function (image, inMobal) {
        return (_jsxs(Fragment, { children: [_jsx(Typography, __assign({ sx: {
                        fontWeight: 'bold',
                        backgroundColor: 'white.main',
                        color: "".concat(descriptionSelected.color, ".main"),
                        width: 'fit-content',
                        paddingX: inMobal ? 2 : 0,
                        paddingY: 1,
                        borderRadius: '25px 25px 0 0',
                    }, variant: "body1" }, { children: image.label })), _jsx(Box
                //onClick={() => setFocusImages(true)}
                , { 
                    //onClick={() => setFocusImages(true)}
                    component: "img", sx: {
                        height: 400,
                        //...(focusImages ? {} : { cursor: 'pointer' }),
                    }, src: image.url, alt: image.label })] }, image.url));
    };
    var renderImages = function (inMobal) {
        if (inMobal === void 0) { inMobal = false; }
        if (isMobile) {
            return;
        }
        return images.length > 1 ? (_jsx(Stack, { children: images.map(function (image) { return renderImage(image, inMobal); }) })) : images.length > 0 ? (renderImage(images[0], inMobal)) : (_jsx(_Fragment, {}));
    };
    return (_jsx(_Fragment, { children: _jsxs(Stack, __assign({ className: "w-full" }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 3 }, { children: _jsx(Stack, { children: _jsx(Stack, { children: _jsx(List, __assign({ sx: {
                                            p: 1,
                                        } }, { children: optionsForDemo.map(function (item, index) {
                                            return item.descriptions.map(function (description) {
                                                return (_jsxs(ListItemButton, __assign({ sx: description.label === selected
                                                        ? {
                                                            borderWidth: '1px',
                                                            borderStyle: 'solid',
                                                            borderColor: item.color
                                                                ? "".concat(item.color, ".main")
                                                                : null,
                                                            borderRadius: '25px',
                                                        }
                                                        : {}, onClick: function () {
                                                        setSelected(description.label);
                                                    } }, { children: [_jsx(ListItemIcon, __assign({ sx: {
                                                                fontSize: '15px',
                                                                color: item.color ? "".concat(item.color, ".main") : null,
                                                            } }, { children: description.icon })), _jsx(Typography, __assign({ sx: {
                                                                color: item.color ? "".concat(item.color, ".main") : null,
                                                            }, variant: "body2" }, { children: description.label }))] }), description.label));
                                            });
                                        }) })) }) }) })), _jsxs(Grid, __assign({ item: true, xs: 12, md: 9 }, { children: [_jsx(Typography, __assign({ sx: { margin: 1 }, variant: "h4", color: "".concat(descriptionSelected.color, ".main") }, { children: selected })), descriptionSelected && (_jsx(Stack, { children: _jsxs(Stack, __assign({ paddingX: 1, paddingY: 1, spacing: 1 }, { children: [details && (_jsx(DisplayMarkdown, { children: details, color: "".concat(descriptionSelected.color, ".main") })), _jsx(Stack, { children: renderImages() })] })) }, selected))] }))] })), _jsx(Modal, __assign({ open: focusImages, onClose: function () { return setFocusImages(!focusImages); } }, { children: _jsx(Box, __assign({ sx: {
                            height: 'auto',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            boxShadow: 24,
                            borderRadius: '25px 25px 0 0',
                        } }, { children: renderImages(true) })) }))] })) }));
};
var OPTION = {
    UTILISATEURS: 'UTILISATEURS',
    PRESENTATION: 'PRESENTATION',
    COLLABORATEUR: 'COLLABORATEUR',
    CLIENT: 'CLIENT',
    ACTIVITE: 'ACTIVITE',
    AFFAIRE: 'AFFAIRE',
    STATISTIQUES: 'STATISTIQUES',
    EQUIPE: 'EQUIPE',
};
var options = (_a = {},
    _a[OPTION.PRESENTATION] = {
        color: 'header',
        descriptions: [
            {
                icon: _jsx(HelpIcon, {}),
                label: "Ce qu'il faut savoir",
                images: [],
                details: "**GAELI** est un outil qui facilite la gestion de vos activit\u00E9s, vos clients, vos affaires et g\u00E9n\u00E8re vos devis !\n\nIl met en avant les statistiques les plus pertinentes de votre business pour vous aider au quotidien.\n\n**Voici les mots \u00E0 connaitre pour bien comprendre ce que propose GAELI !**\n\n- **Utilisateur** : D\u00E9signe nominativement une personne physique utilisant le logiciel GAELI gr\u00E2ce \u00E0 un identifiant d'acc\u00E8s\n- **Collaborateur** : Peut \u00EAtre la r\u00E9plication d'un utilisateur ou une personne qui collabore avec vous dans la gestion d'un client, d'une affaire ou d'une activit\u00E9\n- **Objectif** : D\u00E9finit le but (en tarification ou marge r\u00E9alis\u00E9) qu'un collaborateur doit atteindre\n- **Client** : D\u00E9signe la personne ou l'entit\u00E9 qui requiert un bien ou service donnant lieu \u00E0 la cr\u00E9ation d'une affaire\n- **Affaire** : March\u00E9 conclu ou \u00E0 conclure avec un client contenant le d\u00E9tail, l'ensemble des prix, des produits et services attendus par le client\n- **Devis** : Document d\u00E9taill\u00E9 g\u00E9n\u00E9r\u00E9 \u00E0 partir des produits et services de l'affaire contenant l'ensemble des tarifs propos\u00E9s au client.\n- **Activit\u00E9** : Interaction r\u00E9alis\u00E9 avec un client (un RDV, un \u00E9change t\u00E9l\u00E9phonique...)\n- **Produit / Service** : Bien consomm\u00E9s ou action n\u00E9cessaire afin de satisfaire un besoin client\n- **Gamme de produits / services** : Permets de regrouper par un th\u00E8me un ensemble de produits et services\n- **Famille de gamme de produits / services** : Permets de regrouper par un th\u00E8me un ensemble de gamme de produits et services\n",
            },
        ],
    },
    _a[OPTION.COLLABORATEUR] = {
        color: 'collaborateur',
        descriptions: [
            {
                icon: _jsx(CollaborateurIcon, {}),
                label: 'Gérez vos collaborateurs',
                images: [
                    {
                        label: 'Exemple de fiche collaborateur',
                        url: 'https://i.imgur.com/ROBvq5J.png',
                    },
                ],
                details: "**Saisissez les collaborateurs de votre entreprise avec la possibilit\u00E9 de renseigner :**\n- Une civilit\u00E9, un nom et un pr\u00E9nom\n- Une adresse postale\n- Une adresse email\n- Un t\u00E9l\u00E9phone mobile et fixe\n\nL'adresse postale est saisissable via auto-compl\u00E9tion et g\u00E9olocalisable. *(source Google)*\n\n**Un collaborateur peut \u00EAtre positionn\u00E9 :**\n- Sur une ou plusieurs affaires, ventes de produits et services ou activit\u00E9s\n- Comme collaborateur par d\u00E9faut sur un utilisateur\n\n**Sur la fiche collaborateur, vous pourrez consulter :**\n- Ses **affaires**\n- Ses **activit\u00E9s**\n- Ses **objectifs** (et les saisir)",
            },
        ],
    },
    _a[OPTION.CLIENT] = {
        color: 'client',
        descriptions: [
            {
                icon: _jsx(ClientIcon, {}),
                label: 'Gérez vos clients',
                images: [
                    {
                        //label: "Exemple de liste d'affaires dans la fiche client",
                        label: "Exemple d'une fiche client",
                        url: 'https://i.imgur.com/CZrcw6L.png',
                    },
                    /*{
                                label: "Exemple de liste d'activités dans la fiche client",
                                url: 'https://i.imgur.com/F4Lfex9.png',
                              },*/
                ],
                details: "**Un client peut \u00EAtre un particulier avec :**\n  - Une civilit\u00E9, un nom et un pr\u00E9nom\n  - Une adresse email\n  - Un t\u00E9l\u00E9phone mobile et fixe\n  - Une adresse postale\n\nL'adresse postale est saisissable via auto-compl\u00E9tion et g\u00E9olocalisable. *(source Google)*\n  \n**Un client peut \u00EAtre un professionnel avec :**\n  - Un siret\n  - Une raison sociale\n  - Un type (TPE, PME..)\n  - Code Naf-Ape\n  - Tranche d'effectif\n  - Une adresse postale\n\nL'adresse postale est saisissable via auto-compl\u00E9tion et g\u00E9olocalisable. *(source Google)*\n\nL'ensemble des donn\u00E9es sont auto-saisissables gr\u00E2ce au SIRET. *(source Insee)*\n\n**Un client est avec un statut :**\n- **Suspect** lorsqu'il n'a aucune affaire en cours ou valid\u00E9e\n- **Prospect** lorsqu'il a au moins une affaire en cours et aucune valid\u00E9e\n- **Client** lorsqu'il a au moins une affaire valid\u00E9e\n\nSur la fiche client vous pourrez consulter :\n- Des **contacts** (et les saisir)\n- Des **affaires** (et les saisir)\n- Des **activit\u00E9s** (et les saisir)\n- **L'historique** des \u00E9v\u00E9nements marquants chez ce client\n- **La localisation** de celui-ci si l'adresse est g\u00E9olocalis\u00E9e",
            },
        ],
    },
    _a[OPTION.AFFAIRE] = {
        color: 'affaire',
        descriptions: [
            {
                icon: _jsx(CatalogueIcon, {}),
                label: 'Gérez votre catalogue',
                images: [
                    {
                        label: "Exemple d'un catalogue paramétré",
                        url: 'https://i.imgur.com/gf1y51q.png',
                    },
                ],
                details: "D\u00E9finissez votre catalogue de **produit & service** regroup\u00E9 par **gamme** & **famille**.\n\nVotre catalogue vous permettra de compl\u00E9ter et pr\u00E9remplir les ventes de **produits et services** r\u00E9alis\u00E9s sur vos affaires.\n\nUn **produit / service** est compos\u00E9 d'un **intitul\u00E9**, et peut avoir une **quantit\u00E9** avec **unit\u00E9** rattach\u00E9e, un **tarif** et un **co\u00FBt** par d\u00E9faut (modifiable lors de l'ajout sur une affaire)\n\nLe catalogue personnalisable par un utilisateur administrateur.",
            },
            {
                icon: _jsx(AffaireIcon, {}),
                label: 'Gérez vos affaires',
                images: [
                    {
                        label: "Exemple d'une affaire en cours",
                        url: 'https://i.imgur.com/ucrO5Pv.png',
                    },
                    /*{
                                label: "Exemple d'affaire validée",
                                url: 'https://i.imgur.com/VGMDFXL.png',
                              },
                              {
                                label: "Exemple d'affaire perdue",
                                url: 'https://i.imgur.com/WBQtzL9.png',
                              },*/
                ],
                details: "Saisissez vos affaires depuis la **fiche client** comportant les informations suivantes :\n- Un libell\u00E9\n- Un type *(personnalisable dans l'administration)*\n- Une probabilit\u00E9 (**Possible** / **Engag\u00E9** / **Difficile**)\n- Une date de d\u00E9but et de fin *(optionnel)*\n- Un mois et une ann\u00E9e de signature *(permettant d'inclure l'affaire sur une p\u00E9riode afin d'alimenter les statistiques)*\n- Un commentaire\n- Un d\u00E9tail *(visible dans le devis g\u00E9n\u00E9r\u00E9)*\n\nUne affaire est avec un statut :\n- **En cours** tant qu'elle n'est pas valid\u00E9e\n- **Valid\u00E9e** lorsque celle-ci arrive \u00E0 la derni\u00E8re \u00E9tape\n- **Perdue** lorsque le client se retire de l'affaire\n- **Annul\u00E9e** lorsque le collaborateur se retire de l'affaire\n\nSur l'affaire, ajoutez les produits et services rattach\u00E9s \u00E0 celle-ci en s\u00E9lectionnant dans un premier temps : \n- La **gamme** li\u00E9e au produit / service souhait\u00E9\n- Puis le **produit / service** en question\n\nCela pr\u00E9remplira tous les champs ci-dessous qui resteront modifiables sur les produits et services de l'affaire :\n- La **d\u00E9signation** du produit / service\n- La **quantit\u00E9** et son unit\u00E9\n- Le **tarif** unitaire\n- Le **co\u00FBt** unitaire\n- Les **collaborateurs** qui se partageront la vente",
            },
            /*
                  Tarif (Tarif total) = Tarif unitaire * Quantité
      
            Coût (Coùt total) = Coût unitaire * Quantité
      
            Marge (Marge total) = Tarif - Coût
      
            Portefeuille = Tarif total des affaires ouvertes pour un période lié à la date de signature
      
            Création = Tarif total des affaires ouvertes pour une période lié à la date de création de l'affaire
      
            Forecast = Tarif total prévisionnelle validé = Tarif total validée + (Tarif total en cours difficile * Taux1) + (Tarif total en cours possible * Taux2) + (Tarif total en cours engagée * Taux3)
            */
            {
                icon: _jsx(DocumentIcon, {}),
                label: 'Générez vos devis',
                images: [
                    {
                        label: 'Exemple de devis généré',
                        url: 'https://i.imgur.com/0VbAgeA.png',
                    },
                ],
                details: "Une fois l'affaire cr\u00E9\u00E9e et vos produits et services renseign\u00E9s sur celle-ci, la **g\u00E9n\u00E9ration d'un devis** en format PDF est possible, vous pourrez modifier sur celui-ci :\n- Le **titre**\n- Le **num\u00E9ro** de devis\n- La **date** du devis\n- Le  **destinataire** du devis\n- Les **informations compl\u00E9mentaires** affich\u00E9es en bas de page du devis",
            },
        ],
    },
    _a[OPTION.ACTIVITE] = {
        color: 'activite',
        descriptions: [
            {
                icon: _jsx(ActiviteIcon, {}),
                label: 'Gérez vos activités',
                images: [
                    {
                        label: "Exemple d'activité",
                        url: 'https://i.imgur.com/idFWGZi.png',
                    },
                ],
                details: "Saisissez vos activit\u00E9s depuis votre **fiche client** afin de renseigner :\n- Un type d'activit\u00E9 (RDV, Appel...)\n- Une date de d\u00E9but et de fin *(ou une dur\u00E9e)*\n- Un \u00E9tat (**A faire** / **Effectu\u00E9** / **Annul\u00E9e**)\n- Un ou plusieurs collaborateurs\n- Aucun ou plusieurs contacts client\n\nUne activit\u00E9 **Effectu\u00E9** peut \u00EAtre **A suivre**, **Concluante** ou **Non concluante**.",
            },
        ],
    },
    _a[OPTION.STATISTIQUES] = {
        color: 'affaire',
        descriptions: [
            {
                label: 'Consultez vos ventes et marges réalisées',
                icon: _jsx(StatistiqueIcon, {}),
                images: [
                    {
                        label: 'Exemple de reporting',
                        url: 'https://i.imgur.com/MDXF9bj.png',
                    },
                ],
                details: "Le **reporting** et la **dynamique** peuvent \u00EAtre le bilan de toute l'entreprise ou d'un collaborateur sur une p\u00E9riode souhait\u00E9e.\n        \nLes statistiques sur les **affaires valid\u00E9es** ou les **portefeuilles** se calculent gr\u00E2ce au **mois et \u00E0 l'ann\u00E9e de signature**.\n\nLes statistiques sur les **activit\u00E9s** se calculent gr\u00E2ce \u00E0 la **date de d\u00E9but** de l'activit\u00E9.",
            },
        ],
    },
    _a[OPTION.EQUIPE] = {
        color: 'header',
        descriptions: [
            {
                label: 'Pourquoi une offre premium ?',
                icon: _jsx(StarsIcon, {}),
                images: [],
                details: "**L'offre premium** permet \u00E0 un administrateur de g\u00E9rer :\n\n- Des **droits utilisateurs** pour chacun des utilisateurs *(ajouter, modifier, exporter...)*\n- Des **groupes** avec une **sectorisation** permettant de regrouper plusieurs autres groupes et collaborateurs entre eux\n- Des **visions** pour chaque utilisateur leur permettant d'avoir la **visibilit\u00E9 des clients, affaires, activit\u00E9s et reporting** de l'ensemble des collaborateurs d'un groupe ou d'un collaborateur\n- Des **\u00E9quipes** pour chaque client et affaire, **limitant leurs visibilit\u00E9s** aux collaborateurs de l'\u00E9quipe et \u00E0 ceux qui ont la vision de ces collaborateurs\n",
            },
        ],
    },
    _a);
//# sourceMappingURL=Documentation.js.map